import React, { useEffect, useRef, useState } from "react";
import Switch from "@mui/material/Switch";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TourManagementOptionsSidebar from "../components/tour/TourManagementSidebarOptionsSidebar";
import TourManagementAvailabilityHeader from "../components/TourManagementAvailabilityHeader";
import CustomRadio from "../components/common/CustomRadio";
import CustomDropdown from "../components/common/CustomDropdown";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setOptionsData } from "../reducer/tourReducer";
import { FormControl } from "@mui/material";
import { useOptions } from "../hooks/useOptions";
import { resetOptionEdit } from "../reducer/tourEditReducer";

const options = [
  "infant",
  "adult",
  "senior",
  "student",
  "military",
  "eu_citizens",
];

// todo: it have an issue with price per individual here not returning type after saving

function TourManagementPackageAvailabilityPriceCategoryPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { optionsData, PrepackageDataId, packageData } = useSelector(
    (state: RootState) => state.tour
  );
  const {
    tourEdit,
    optionId,
    id: editPackageId,
  } = useSelector((state: RootState) => state.edit);
  const { createPreOptions } = useOptions();

  useEffect(() => {
    if (location.state && location.state.optionData) {
      dispatch(setOptionsData(location.state.optionData));
    }
  }, [location.state, dispatch]);

  // Ensure groupPricing is always an array
  const groupPricing = optionsData.groupPricing || [];
  const progressref = useRef(16);

  // states
  const [switchActive, setSwitchActive] = useState(false);
  const [pricingOption, setPricingOption] = useState<string | undefined>(
    optionsData.pricingOption
  );

  useOnLoadPage({ tabActive: "create" });

  const handleAddAgeGroup = (option: string) => {
    const data = optionsData.pricing ? [...optionsData.pricing] : [];
    data.push({ category: option });
    dispatch(setOptionsData({ ...optionsData, pricing: data }));
  };

  const handleRemoveAgeGroup = (index: number) => {
    const data = optionsData.pricing ? [...optionsData.pricing] : [];
    const updatedData = data.filter((_, idx) => idx !== index);
    dispatch(setOptionsData({ ...optionsData, pricing: updatedData }));
  };

  const handleAddGroup = () => {
    const data = [...groupPricing];
    data.push({ name: "" });
    dispatch(setOptionsData({ ...optionsData, groupPricing: data }));
  };

  const handleRemoveGroup = (index: number) => {
    const data = [...groupPricing];
    const updatedData = data.filter((_, idx) => idx !== index);
    dispatch(setOptionsData({ ...optionsData, groupPricing: updatedData }));
  };

  const handleSwitchChange = () => setSwitchActive((prev) => !prev);

  const buttonElement = (
    <button className={Classname.buttonElement}>Add age group</button>
  );

  const onContinue = async () => {
    const updatedPackageData = {
      ...optionsData,
      _id: optionsData._id,
      progress: Number(progressref.current),
    };

    // Clean up irrelevant keys based on pricingOption
    let cleanedOptionsData = { ...optionsData };

    if (optionsData.pricingOption === "fixed") {
      // Remove all group/age related keys
      delete cleanedOptionsData.pricingCategories;
      delete cleanedOptionsData.pricePerAgeGroup;
      delete cleanedOptionsData.groupPricing;
      delete cleanedOptionsData.pricing;
      // Only include fixed pricing payload
      const pricingPayload = {
        pricePerIndividual: [
          {
            calculatedPrice: optionsData.samePricing?.calculatedPrice,
            value: optionsData.samePricing?.singlePrice,
            description: "Standard pricing for individual entry",
          },
        ],
      };
      const updatedPackageData2 = {
        ...cleanedOptionsData,
        ...updatedPackageData,
        ...pricingPayload,
      };
      dispatch(setOptionsData(updatedPackageData2));
      // Remove from localStorage if present
      if (localStorage.getItem("optionsData")) {
        const stored = JSON.parse(localStorage.getItem("optionsData") || "{}");
        if (stored.pricingOption === "fixed") {
          delete stored.pricingCategories;
          delete stored.pricePerAgeGroup;
          delete stored.groupPricing;
          delete stored.pricing;
          localStorage.setItem("optionsData", JSON.stringify(stored));
        }
      }
      try {
        if (tourEdit) {
          dispatch(resetOptionEdit());
          dispatch(setOptionsData(updatedPackageData2));
          const pkgId = packageData._id;
          navigate(`/manage/product/${pkgId}/${optionId}`, {
            state: {
              fromEdit: true,
              option: updatedPackageData2,
              packageId: pkgId,
            },
          });
          return;
        } else {
          await createPreOptions(updatedPackageData2);
        }
        navigate(Paths.tourManagementPackageOptionsAvailabilityCapacity);
      } catch (error) {
        console.error("Error saving package:", error);
      }
      return;
    }

    let pricingPayload = {};
    // ...existing code for other pricing options...
    if (
      optionsData.pricingOption === "vehicle" &&
      Array.isArray(optionsData.groupPricing)
    ) {
      // ...existing code...
    } else if (
      optionsData.pricingOption === "age_group" &&
      Array.isArray(optionsData.pricing)
    ) {
      // ...existing code...
    }

    const updatedPackageData2 = {
      ...cleanedOptionsData,
      ...updatedPackageData,
      ...pricingPayload,
    };

    dispatch(setOptionsData(updatedPackageData2));
    try {
      if (tourEdit) {
        dispatch(resetOptionEdit());
        dispatch(setOptionsData(updatedPackageData2));
        const pkgId = packageData._id;
        navigate(`/manage/product/${pkgId}/${optionId}`, {
          state: {
            fromEdit: true,
            option: updatedPackageData2,
            packageId: pkgId,
          },
        });
        return;
      } else {
        await createPreOptions(updatedPackageData2);
      }
      navigate(Paths.tourManagementPackageOptionsAvailabilityCapacity);
    } catch (error) {
      console.error("Error saving package:", error);
    }
  };

  const handleBack = () => navigate(-1);

  console.log("package", optionsData);

  // Only run initial setup once
  const didInit = useRef(false);

  useEffect(() => {
    if (didInit.current) return;
    if (optionsData.priceByGroup === false) {
      dispatch(
        setOptionsData({
          ...optionsData,
          samePrice: true,
          pricingOption: "fixed",
        })
      );
      setPricingOption("fixed");
    } else if (
      typeof optionsData.samePrice === "undefined" &&
      typeof optionsData.pricingOption === "undefined"
    ) {
      dispatch(
        setOptionsData({
          ...optionsData,
          samePrice: true,
          pricingOption: "fixed",
        })
      );
      setPricingOption("fixed");
    } else if (optionsData.pricingOption) {
      setPricingOption(optionsData.pricingOption);
    }
    didInit.current = true;
    // eslint-disable-next-line
  }, []);

  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementOptionsSidebar selected={4} />
        <div className={Classname.detail}>
          <TourManagementAvailabilityHeader active={1} />

          {optionsData.priceByGroup ? (
            <>
              <div className={Classname.title}>
                Tell us more about your group pricing:
              </div>
              <div className={Classname.title2}>Group/Vehicle:</div>
              {/* Price per group */}
              {groupPricing.map((pricing, index) => {
                const from =
                  index === 0 ? 1 : (groupPricing[index - 1].to || 1) + 1;

                return (
                  <div
                    key={index}
                    className="flex w-full p-3 h-fit border text-start flex-col md:flex-row gap-4 justify-between items-center border-gray-300 rounded-md px-4 mt-2"
                  >
                    <div className="flex gap-24 items-center">
                      <input
                        type="text"
                        placeholder="Group name"
                        className="border border-gray-300 rounded-md px-2 py-2 h-12"
                        value={pricing.name}
                        onChange={(e) => {
                          const data = [...groupPricing];
                          data[index] = {
                            ...data[index],
                            name: e.target.value,
                          };
                          dispatch(
                            setOptionsData({
                              ...optionsData,
                              groupPricing: data,
                            })
                          );
                        }}
                      />
                    </div>

                    {/* From - To range input */}
                    <div>
                      <div className="font-bold text-gray-500">
                        Set number of members
                      </div>
                      <div className="flex items-center gap-4">
                        <p className="text-lg mt-2">
                          <span className="pr-5">{from}</span> to
                        </p>
                        <input
                          type="number"
                          min={from}
                          placeholder="Enter max number"
                          className="border border-gray-300 rounded-md px-2 py-2 mt-2"
                          value={pricing.to || ""}
                          onChange={(e) => {
                            const data = [...groupPricing];
                            data[index] = {
                              ...data[index],
                              from,
                              to: Math.abs(parseInt(e.target.value, 10)) || 0,
                            };
                            dispatch(
                              setOptionsData({
                                ...optionsData,
                                groupPricing: data,
                              })
                            );
                          }}
                        />
                      </div>
                    </div>

                    <div
                      className="text-red-600 font-bold cursor-pointer"
                      onClick={() => handleRemoveGroup(index)}
                    >
                      Remove
                    </div>
                  </div>
                );
              })}

              <span
                className="font-bold text-sm lg:text-base text-primary py-2 cursor-pointer"
                onClick={handleAddGroup}
              >
                Add group
              </span>
            </>
          ) : (
            <>
              {/* Price per person */}
              <div className={Classname.title}>
                Tell us more about your prices:
              </div>
              <CustomRadio
                label="The price is the same for everyone, eg: per participant"
                value="fixed"
                selected={pricingOption}
                onSelect={(val) => {
                  setPricingOption(val);
                  dispatch(
                    setOptionsData({
                      ...optionsData,
                      samePrice: true,
                      pricingOption: val,
                    })
                  );
                }}
              />
              <CustomRadio
                label="Price depends on age, eg: adults, child, senior, etc"
                value="age_group"
                selected={pricingOption}
                onSelect={(val) => {
                  setPricingOption(val);
                  dispatch(
                    setOptionsData({
                      ...optionsData,
                      samePrice: false,
                      pricingOption: val,
                    })
                  );
                }}
              />
              {pricingOption === "age_group" && (
                <div>
                  <div className="flex flex-wrap justify-between items-center">
                    <div className={Classname.title2}>Price categories:</div>
                    <div className="flex gap-2 items-center">
                      <div className={Classname.title2}>
                        Show advanced settings
                      </div>
                      <Switch
                        color="primary"
                        className="mt-4"
                        checked={switchActive}
                        onChange={handleSwitchChange}
                      />
                    </div>
                  </div>

                  {optionsData?.pricing?.map((pricing, index) => (
                    <div
                      key={index}
                      className="flex w-full p-3 h-fit border text-start flex-col-reverse md:flex-row justify-between border-gray-300 rounded-md px-4 mt-2"
                    >
                      <div className="flex flex-wrap gap-10 lg:justify-center">
                        <div className="flex gap-24">
                          <div className={Classname.title2}>
                            {pricing?.category}
                          </div>
                          <div>
                            <div className="mt-6">Set an age range:</div>
                            <div className="flex mt-2 gap-4 items-center">
                              <FormControl>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={pricing.minAge ? pricing.minAge : 0}
                                  onChange={(e) => {
                                    if (!optionsData?.pricing) return;
                                    const data = [...optionsData.pricing];
                                    const newObject = {
                                      ...data[index],
                                      minAge: e.target.value as number,
                                    };
                                    data[index] = newObject;
                                    dispatch(
                                      setOptionsData({
                                        ...optionsData,
                                        pricing: data,
                                      })
                                    );
                                  }}
                                  className="h-8"
                                  MenuProps={{
                                    PaperProps: {
                                      style: {
                                        maxHeight: 200,
                                      },
                                    },
                                  }}
                                >
                                  {[...Array(99)].map((_, index) => (
                                    <MenuItem key={index} value={index + 1}>
                                      {index + 1}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <div> to</div>
                              <FormControl>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={pricing.maxAge ? pricing.maxAge : 0}
                                  onChange={(e) => {
                                    if (!optionsData?.pricing) return;
                                    const data = [...optionsData.pricing];
                                    const newObject = {
                                      ...data[index],
                                      maxAge: e.target.value as number,
                                    };
                                    data[index] = newObject;
                                    dispatch(
                                      setOptionsData({
                                        ...optionsData,
                                        pricing: data,
                                      })
                                    );
                                  }}
                                  className="h-8"
                                  MenuProps={{
                                    PaperProps: {
                                      style: {
                                        maxHeight: 200,
                                      },
                                    },
                                  }}
                                >
                                  {[...Array(99)].map((_, index) => (
                                    <MenuItem key={index} value={index + 1}>
                                      {index + 1}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                        {switchActive && (
                          <div>
                            <div className="mt-6 font-semibold">
                              Advanced Settings
                            </div>
                            <div>Is this category permitted?</div>
                            <div className="flex gap-10">
                              <CustomRadio
                                value={true}
                                label="Yes"
                                selected={pricing.categoryPermitted}
                                onSelect={() => {
                                  if (!optionsData?.pricing) return;
                                  const data = [...optionsData.pricing];
                                  const newObject = {
                                    ...data[index],
                                    categoryPermitted: true,
                                  };
                                  data[index] = newObject;
                                  dispatch(
                                    setOptionsData({
                                      ...optionsData,
                                      pricing: data,
                                    })
                                  );
                                }}
                              />
                              <CustomRadio
                                value={false}
                                label="No"
                                selected={pricing.categoryPermitted}
                                onSelect={() => {
                                  if (!optionsData?.pricing) return;
                                  const data = [...optionsData.pricing];
                                  const newObject = {
                                    ...data[index],
                                    categoryPermitted: false,
                                  };
                                  data[index] = newObject;
                                  dispatch(
                                    setOptionsData({
                                      ...optionsData,
                                      pricing: data,
                                    })
                                  );
                                }}
                              />
                            </div>
                            <div>Is this category free of charge?</div>
                            <div className="flex gap-10">
                              <CustomRadio
                                value={true}
                                label="Yes"
                                selected={pricing.categoryFree}
                                onSelect={() => {
                                  if (!optionsData?.pricing) return;
                                  const data = [...optionsData.pricing];
                                  const newObject = {
                                    ...data[index],
                                    categoryFree: true,
                                  };
                                  data[index] = newObject;
                                  dispatch(
                                    setOptionsData({
                                      ...optionsData,
                                      pricing: data,
                                    })
                                  );
                                }}
                              />
                              <CustomRadio
                                value={false}
                                label="No"
                                selected={pricing.categoryFree}
                                onSelect={() => {
                                  if (!optionsData?.pricing) return;
                                  const data = [...optionsData.pricing];
                                  const newObject = {
                                    ...data[index],
                                    categoryFree: false,
                                  };
                                  data[index] = newObject;
                                  dispatch(
                                    setOptionsData({
                                      ...optionsData,
                                      pricing: data,
                                    })
                                  );
                                }}
                              />
                            </div>

                            <div>
                              {pricing.category !== "adult" ? (
                                <div>
                                  <div>Do they need an Adult with them?</div>

                                  <div className="flex gap-10">
                                    <CustomRadio
                                      value={true}
                                      label="Yes"
                                      selected={pricing.adultRequired}
                                      onSelect={() => {
                                        if (!optionsData?.pricing) return;
                                        const data = [...optionsData.pricing];
                                        const newObject = {
                                          ...data[index],
                                          adultRequired: true,
                                        };
                                        data[index] = newObject;
                                        dispatch(
                                          setOptionsData({
                                            ...optionsData,
                                            pricing: data,
                                          })
                                        );
                                      }}
                                    />
                                    <CustomRadio
                                      value={false}
                                      label="No"
                                      selected={pricing.adultRequired}
                                      onSelect={() => {
                                        if (!optionsData?.pricing) return;
                                        const data = [...optionsData.pricing];
                                        const newObject = {
                                          ...data[index],
                                          adultRequired: false,
                                        };
                                        data[index] = newObject;
                                        dispatch(
                                          setOptionsData({
                                            ...optionsData,
                                            pricing: data,
                                          })
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        className="mt-6 text-red-600 font-bold cursor-pointer"
                        onClick={() => handleRemoveAgeGroup(index)}
                      >
                        Remove
                      </div>
                    </div>
                  ))}

                  <CustomDropdown
                    button={buttonElement}
                    options={options}
                    onSelect={handleAddAgeGroup}
                  />
                </div>
              )}
            </>
          )}
          <div className={Classname.buttonsContainer}>
            <button className={Classname.saveButton} onClick={handleBack}>
              Back
            </button>
            <button className={Classname.continueButton} onClick={onContinue}>
              Save and {!tourEdit ? "Continue" : "Exit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageAvailabilityPriceCategoryPage;

const Classname = {
  buttonElement:
    "font-bold w-fit flex items-center gap-2 cursor-pointer text-primary1 py-3 px-3",
  gridContainer: "grid grid-cols-4 gap-4",
  gridItem: "flex text-sm items-center h-8 gap-2 p-4",
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full pb-80",
  title: "font-bold text-lg mt-6 mb-2",
  title2: "font-bold lg:text-lg mt-6 mb-2",
  input: "flex w-24 h-8 border border-gray-300 rounded-md px-4 mt-2",
  inputSmall: "flex w-10 h-8 border bg-gray-200 rounded-md px-2 mt-2",
  inputPrice: "flex w-24 h-8 border bg-gray-200 rounded-md px-2 mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6",
  description: "flex text-base mb-4",
  buttonsContainer: "flex flex-1 justify-between lg:justify-end gap-3 mt-10",
  highlightButton:
    "font-bold flex items-center gap-2 mt-10 cursor-pointer text-primary1 py-4",
  saveButton:
    "h-12 px-6 flex items-center justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
